import { initEm } from './init';
import { subscribe, unsubscribe } from './tools/events';

// pageReady fired off when Vue has mounted
subscribe('pageReady', () => {
    initEm();

    const trust = document.getElementById('trustbox');
    if (trust) {
        let scriptEle = document.createElement('script');
        scriptEle.setAttribute(
            'src',
            '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
        );
        document.body.appendChild(scriptEle);
        scriptEle.addEventListener('load', function () {
            window.Trustpilot.loadFromElement(trust);
            trust.style.opacity = '1';
        });
    }
});

unsubscribe('pageReady');
